import { mapGetters, mapActions } from 'vuex';
import axios from '@/config/axios';

export default {
  name: 'OldBookCartDrawer',
  data() {
    return {
      showCheckoutModal: false,
      isSubmittingOrder: false,
      orderForm: {
        fullname: '',
        phone: '',
        address: '',
        note: ''
      }
    };
  },
  computed: {
    ...mapGetters('cart', [
      'cartItems',
      'totalItems',
      'totalPrice',
      'totalWeight',
      'isDrawerOpen',
      'groupedByBooth'
    ]),
    isOpen() {
      return this.isDrawerOpen;
    },
    isLoggedIn() {
      return !!localStorage.getItem('token');
    },
    currentUser() {
      try {
        const user = localStorage.getItem('user');
        if (user) return JSON.parse(user);
      } catch (e) {
        console.error(e);
      }
      return null;
    }
  },
  watch: {
    isOpen(open) {
      if (open) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', this.handleKeydown);
      } else {
        if (!this.showCheckoutModal) {
          document.body.style.overflow = '';
        }
        window.removeEventListener('keydown', this.handleKeydown);
      }
    },
    showCheckoutModal(open) {
      if (open) {
        document.body.style.overflow = 'hidden';
      } else if (!this.isOpen) {
        document.body.style.overflow = '';
      }
    }
  },
  mounted() {
    this.prefillUser();
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = '';
  },
  methods: {
    ...mapActions('cart', [
      'removeFromCart',
      'clearCart',
      'closeDrawer'
    ]),
    prefillUser() {
      if (this.currentUser) {
        this.orderForm.fullname = this.currentUser.fullname || this.currentUser.name || '';
        this.orderForm.phone = this.currentUser.phone || '';
        this.orderForm.address = this.currentUser.address || '';
      }
    },
    closeCart() {
      this.closeDrawer();
    },
    handleKeydown(e) {
      if (e.key === 'Escape') {
        if (this.showCheckoutModal) {
          this.closeCheckoutModal();
        } else if (this.isOpen) {
          this.closeCart();
        }
      }
    },
    removeItem(id, name) {
      this.removeFromCart(id);
      this.$toast.info(`Đã xóa "${name || 'cuốn sách'}" khỏi giỏ hàng.`);
    },
    confirmClearCart() {
      if (this.totalItems === 0) return;
      if (window.confirm('Bạn có chắc chắn muốn xóa toàn bộ sách trong giỏ hàng không?')) {
        this.clearCart();
        this.$toast.info('Đã làm trống giỏ hàng.');
      }
    },
    goToOldBooks() {
      this.closeCart();
      if (this.$route.path !== '/old-books') {
        this.$router.push('/old-books');
      }
    },
    goToBooth(boothId) {
      if (!boothId) return;
      this.closeCart();
      this.$router.push(`/old-books/${boothId}`);
    },
    openCheckoutModal() {
      if (this.totalItems === 0) return;
      this.prefillUser();
      this.showCheckoutModal = true;
    },
    closeCheckoutModal() {
      this.showCheckoutModal = false;
    },
    submitOrder() {
      if (!this.orderForm.fullname || !this.orderForm.phone || !this.orderForm.address) {
        this.$toast.warning('Vui lòng điền đầy đủ các trường thông tin bắt buộc (*)');
        return;
      }

      this.isSubmittingOrder = true;

      // Prepare order summary payload
      const orderPayload = {
        fullname: this.orderForm.fullname,
        phone: this.orderForm.phone,
        address: this.orderForm.address,
        note: this.orderForm.note,
        totalPrice: this.totalPrice,
        totalWeight: this.totalWeight,
        items: this.cartItems.map((item) => ({
          id: item.id,
          boothId: item.boothId,
          boothName: item.boothName,
          bookId: item.bookId,
          name: item.name,
          price: item.price,
          type: item.type,
          sellerId: item.sellerId
        }))
      };

      // In real workflow, send notification/order to seller
      setTimeout(() => {
        this.isSubmittingOrder = false;
        this.showCheckoutModal = false;
        this.clearCart();
        this.closeCart();
        this.$toast.success(
          'Đã gửi thông tin đặt mua thành công! Người bán sẽ sớm liên hệ xác nhận đơn hàng qua SĐT/Zalo của bạn.'
        );
      }, 700);
    },
    getCoverUrl(path) {
      const defaultPlaceholder =
        "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f8fafc'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%2394a3b8' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      if (!path || typeof path !== 'string') return defaultPlaceholder;
      if (
        path.startsWith('http://') ||
        path.startsWith('https://') ||
        path.startsWith('data:') ||
        path.startsWith('blob:')
      ) {
        return path;
      }
      if (!path.includes('/') && !path.includes('\\') && !path.includes(':')) {
        return 'data:image/jpeg;base64,' + path;
      }

      let cleanPath = path.replace(/\\/g, '/');
      if (cleanPath.includes('oldbooks/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('oldbooks/'));
      } else if (cleanPath.includes('cover/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('cover/'));
      } else if (cleanPath.includes('storge/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('storge/'));
      }
      cleanPath = cleanPath.replace(/^[A-Za-z]:/, '').replace(/^\/+/, '');

      const apiServiceUrl = process.env.VUE_APP_API_SERVICE_URL || process.env.VUE_APP_API_URL || '';
      const apiHost = apiServiceUrl.replace(/\/api\/?$/, '').replace(/\/+$/, '');

      if (apiHost) {
        return `${apiHost}/${cleanPath}`;
      }
      return `/${cleanPath}`;
    },
    handleImageError(event) {
      if (event && event.target) {
        event.target.onerror = null;
        event.target.src =
          "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f8fafc'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%2394a3b8' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      }
    },
    formatPrice(price) {
      if (!price && price !== 0) return '0 đ';
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
    },
    formatWeight(grams) {
      if (!grams || grams <= 0) return '0g';
      if (grams >= 1000) {
        return (grams / 1000).toFixed(1).replace('.0', '') + ' kg';
      }
      return grams + 'g';
    },
    getConditionLabel(verStatus) {
      const conditions = {
        0: 'Rất mới (95-100%)',
        1: 'Như mới (85-94%)',
        2: 'Khá mới (70-84%)',
        3: 'Trung bình (50-69%)',
        4: 'Cũ (< 50%)'
      };
      return conditions[verStatus] || 'Tốt';
    }
  }
};
